const translations = {
    deleteButtonText: 'Delete Customer',
    deleteConfirmationBody:
        'Deleting this customer will remove them from your customer list. Any associated jobs and sites will remain. This action cannot be undone.',
    deleteConfirmationTitle: 'Are you sure?'
};

export default translations;
